"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleSuggestions = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var ExampleSuggestions = function ExampleSuggestions(props) {
  var _ref = (0, hooks_1.useSearch)(),
      setSearchTerm = _ref.setSearchTerm;

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("h3", null, "Suggestions"), react_1.default.createElement("ul", null, props.suggestions.map(function (suggestion) {
    return react_1.default.createElement("li", {
      onClick: function onClick() {
        return setSearchTerm(suggestion.text);
      }
    }, suggestion.text);
  })));
};

exports.ExampleSuggestions = ExampleSuggestions;